import React from 'react';
import InstitutionManagementPage from './InstitutionManagementComponents/InstitutionManagementPage';

const InstitutionManagementView = (props) => {
  return <InstitutionManagementPage {...props} />;
};

export default InstitutionManagementView;
